import { Button, Checkbox, DataSource, HorizontalSpacer, Label, Layout, Panel, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBillingProfileCompareOptions extends Layout {
    buttonExtraPayFields: Button;
    buttonFreightItemFields: Button;
    buttonHandlingReqFields: Button;
    buttonMovementFields: Button;
    buttonOCFields: Button;
    buttonOrderFields: Button;
    buttonRefNoFields: Button;
    buttonStopFields: Button;
    checkboxAutoCompare: Checkbox;
    checkboxExtraPayAdd: Checkbox;
    checkboxExtraPayChanges: Checkbox;
    checkboxExtraPayDeletes: Checkbox;
    checkboxFreightItemAdd: Checkbox;
    checkboxFreightItemChange: Checkbox;
    checkboxFreightItemDelete: Checkbox;
    checkboxHandlingReqAdd: Checkbox;
    checkboxHandlingReqChg: Checkbox;
    checkboxHandlingReqDelete: Checkbox;
    checkboxMovementChange: Checkbox;
    checkboxNotesAdd: Checkbox;
    checkboxNotesDelete: Checkbox;
    checkboxOCAdd: Checkbox;
    checkboxOCChange: Checkbox;
    checkboxOCDelete: Checkbox;
    checkboxOrderChange: Checkbox;
    checkboxRefNoAdd: Checkbox;
    checkboxRefNoChange: Checkbox;
    checkboxRefnoDelete: Checkbox;
    checkboxStopAdd: Checkbox;
    checkboxStopDelete: Checkbox;
    checkboxUpdateDatabase: Checkbox;
    horizontalspacer1: HorizontalSpacer;
    label7: Label;
    labelAddColumn: Label;
    labelAutoCompareOptions: Label;
    labelChangeColumn: Label;
    labelDeleteColumn: Label;
    labelExtraPay: Label;
    labelFreightItem: Label;
    labelHandlingReq: Label;
    labelInfo: Label;
    labelMovementAdd: Label;
    labelMovementDelete: Label;
    labelMovements: Label;
    labelNoteChanges: Label;
    labelNotes: Label;
    labelOrderAdd: Label;
    labelOrderDelete: Label;
    labelOrders: Label;
    labelOtherCharges: Label;
    labelPassThrough: Label;
    labelRefNo: Label;
    labelStopAdd: Label;
    labelStops: Label;
    panelAutoCompareOptions: Panel;
    panelCheckBoxes: Panel;
    panelColumnHeaders: Panel;
    panelCompareFieldsMain: Panel;
    panelCompareOptions: Panel;
    panelLeft: Panel;
    panelPassThrough: Panel;
    panelRight: Panel;
    panelRowLabels: Panel;
    sourceEdiAddChgOrder: DataSource;
    sourceEdibillingProfileDisplay: DataSource;
    sourceEdipartnerXcmp: DataSource;
    table1: Table;
    textboxAutoCompareRt: Textbox;
}
